/* eslint-disable react/no-unescaped-entities */
import { SettingsCard } from '~/components/unified/SettingsCard';
import { AccountApiVersions } from '~/generated/graphql';

import { APIVersionsList } from './APIVersionsList';
/**
 * @todo convert /docs to react-router Link
 */

type APIVersionsProps = {
  apiVersions: AccountApiVersions;
  onUpgrade: (apiName: string) => void;
};
export const APIVersions = (props: APIVersionsProps) => {
  return (
    <SettingsCard>
      <SettingsCard.Header>
        <SettingsCard.Heading>API Versions</SettingsCard.Heading>
        <p>
          Our API version and your corresponding account's versions are listed
          below. You can find a{' '}
          <a
            className="ck-link"
            href="https://help.clearbit.com/hc/en-us/articles/115015797408"
          >
            full version changelog here
          </a>
          , and learn more about how versioning works{' '}
          <a className="ck-link" href="/docs">
            in our docs
          </a>
          .
        </p>
      </SettingsCard.Header>
      <SettingsCard.Body className="grid gap-6 !px-0">
        <APIVersionsList {...props} />
      </SettingsCard.Body>
    </SettingsCard>
  );
};
